import { ChangeDetectionStrategy, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { ConfirmDialogViewModel, defaultConfirmDialogViewModelValues } from './confirm-dialog.view-model';

@Component({
  selector: 'osn-cxb-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  @ViewChild(DialogComponent) private readonly dialog: DialogComponent;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogViewModel) {
    this.data = { ...defaultConfirmDialogViewModelValues, ...data };
  }

  public closeDialog(result: boolean): void {
    this.dialog.closeDialog(result);
  }
}
